/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Republish_BtnInputs */

const vi_einvoice_stuck_republish_btn = /** @type {(inputs: Einvoice_Stuck_Republish_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành lại`)
};

/**

* @param {Einvoice_Stuck_Republish_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_republish_btn = /** @type {((inputs?: Einvoice_Stuck_Republish_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Republish_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_republish_btn(inputs)
});